// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/InstagramAccounts_SalvarTokenResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /instagram/accounts/salvar_token
 *
 * Action endpoint — emits a confirmation message after the page_access_token
 * is updated upstream ("Token atualizado com sucesso!").
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface InstagramAccounts_SalvarTokenResponseDados {
message: string
}

export type InstagramAccounts_SalvarTokenResponse = ApiResponse<InstagramAccounts_SalvarTokenResponseDados>;

registerResponseContract('InstagramAccounts_SalvarTokenResponse', {
  message: { type: 'string',  required: true },
})
